import React, { useEffect, useRef, useState } from "react";
import styles from '../styles/studentsacheivements.module.scss';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Card from "react-bootstrap/Card";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "./CustomImage"; 
import fetchUtil from "../utils/fetchUtil";
import { sliderSpeed } from "../utils/constants";

interface Props {
  customClass?: boolean;
  slug: string
}

const StudentsAcheivents: React.FC<Props> = ({ customClass, slug }) => {
  const sliderRef = useRef<Slider>(null);
  const [achievementData, setAchievementData] = useState<any>({})
  
  const settings = {
    dotsClass: styles.sliderDots,
    dots: true,
    infinite: false,
    speed: sliderSpeed.desktopSpeed,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false,
          speed: sliderSpeed.mobileSpeed,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          speed: sliderSpeed.mobileSpeed,
        }
      }
    ]
  };

  useEffect(() => {
    fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/${slug}`, 'GET', {}, '', false)
      .then((res: any) => setAchievementData(res))
  }, [])

  return (
    achievementData?.length > 0
      ? <div id="students-acheivements" className={styles.studentsAcheivement}>
        <Container>
          <Row className="text-center">
            <div >
              <h2>Our Students Achievements</h2>
            </div>
          </Row>
          <Row>
            <Col>
            <div className={styles.batchesSlider}>
              <Slider {...settings} ref={sliderRef} className={styles.slider}>
                {
                  achievementData.map((student: any) => {
                    return (
                      <div className={styles.sliderCardDiv}>
                        <Card className={styles.cardCust} style={customClass ? { minHeight: '250px' } : {}}>
                          <div className={styles.studeImgDiv}>
                            <CustomImage src={student.studentImageUrl} alt={student.studentImageAltTag} layout='responsive' height={160} width={160} className={styles.imgFrame} />
                          </div>
                          <Card.Body className={styles.cardBody}>
                            <Card.Text className={styles.textName} >{student.name}</Card.Text>
                            {
                              student.points?.length > 0 &&
                              student.points.map((point: any) => {
                                return <Card.Text className={styles.subTitle} style={customClass ? { textAlign: 'center' } : {}}>
                                  <span>{point.label} :</span> {point.value}
                                </Card.Text>
                              })
                            }
                          </Card.Body>
                        </Card>
                      </div>
                    )
                  })
                }
              </Slider>
              {achievementData?.length > 3 && <div className={styles.arrowsClass}>
                <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickPrev()}>
                  <CustomImage src='/new-images/left-arrow.svg' height={17} width={10} alt={"left-arrow"} />
                </div>
                <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickNext()}>
                  <CustomImage src='/new-images/right-arrow.svg' height={17} width={10} alt={"right-arrow"} />
                </div>
              </div>}
            </div>
            </Col>
          </Row>
        </Container>
      </div>
      : null
  );
}

export default StudentsAcheivents;